import React from "react";
import { createRoot } from "react-dom/client";

// third party
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

// authentication
import { AuthProvider } from "react-auth-kit";

// project imports
import * as serviceWorker from "serviceWorker";
import App from "App";
import configureStore from "store";

// Redux Persist
import { PersistGate } from "redux-persist/integration/react";

// style + assets
import "assets/scss/style.scss";
import config from "./config";

// ==============================|| REACT DOM RENDER  ||============================== //

const { store, persistor } = configureStore();
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthProvider
          authType={"cookie"}
          authName={"_plansas_auth"}
          cookieDomain={window.location.hostname}
          cookieSecure={false}
        >
          <BrowserRouter basename={config.basename}>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
